<template>
    <div class="card p-shadow-app">
        <Toast :style="{ width: $isMobile() ? '85vw' : '' }" />
        <Loading :active.sync="loading" :isFullPage="true"></Loading>
        <div class="card p-shadow-app">
            <header class="jumbotron">
                <h3>Solicitação de Documentação de Equipamento - Configurações</h3>
            </header>
            <form id="NotificationSMSRequestDocs" name="NotificationSMSRequestDocs" class="p-col-12 p-md-12" @submit.prevent="save">

                <div class="p-fluid p-formgrid p-grid">
                    <div class="p-mt-3 p-field p-col-12 p-md-4">
                        <div class="p-mb-1"><b>Ativar Template</b></div>
                        <Checkbox v-model="form.is_active" :binary="true" class="p-mt-2" />
                    </div>
                </div>

                <h5>Mensagem de Envio (Pergunta)</h5>
                <hr />

                <div class="p-fluid p-formgrid p-grid">
                    <div class="p-field p-col-12 p-md-6">
                        <label>Nome do Template</label>
                        <InputText v-model="form.name" required />
                    </div>
                    <div class="p-field p-col-12 p-md-6">
                        <label>Descrição</label>
                        <InputText v-model="form.description" />
                    </div>
                </div>

                <div class="p-fluid p-formgrid p-grid">
                    <div class="p-field p-col-12 p-md-12">
                        <label class="p-mb-2"><b>Conteúdo da Mensagem</b></label>
                        <div class="p-mb-2">
                            <small :class="charCountClass">{{ plainTextLength }} / {{ charLimit }} caracteres</small>
                        </div>
                        <AppTemplateEditor
                          :content.sync="form.content"
                          :tags="availableTags"
                          placeholder="Escreva a sua mensagem..."
                          @update:text="handleTextUpdate"
                        />
                    </div>
                </div>

                <div class="p-mt-5 p-text-right">
                    <Button label="Testar SMS" icon="pi pi-send" class="p-button-info p-mr-2" type="button" @click.prevent="openTestDialog" :disabled="loading" />
                    <Button label="Gravar Configuração" icon="pi pi-save" class="p-button-success" type="submit" :loading="loading" />
                </div>
            </form>
        </div>

        <Dialog header="Testar Envio de SMS" :visible.sync="testDialogVisible" :modal="true" :closable="true" :style="{ width: $isMobile() ? '95vw' : '50vw' }">
             <div class="p-fluid">
                <div class="p-field">
                    <label>Número de Telefone</label>
                    <InputText v-model="testForm.recipient" placeholder="+351912345678" />
                </div>
                 <div class="p-d-flex p-jc-end p-mt-3">
                     <Button label="Enviar Teste" icon="pi pi-send" @click="sendTest" :loading="testLoading" />
                 </div>
            </div>
        </Dialog>
    </div>
</template>

<script>
import AppTemplateEditor from '../components/elements/AppTemplateEditor.vue';
import notificationsService from '../services/notifications.service';
import Loading from "vue-loading-overlay";

export default {
  name: "NotificationSettingSMSRequestDocs",
  components: { Loading, AppTemplateEditor },
  data() {
    return {
      loading: false,
      testLoading: false,
      testDialogVisible: false,
      providerId: null,
      templateId: null,
      charLimit: 290,
      plainTextContent: '',

      form: {
        code: 'sms-request-equipment-documentation',
        name: 'Solicitação de Documentação de Equipamento',
        description: '',
        content: '',
        is_active: true
      },

      replyRules: [],
      availableActions: [],

      testForm: { recipient: '', data: {} },
      testPreview: '',
      availableTags: []
    };
  },
  computed: {
    plainTextLength() { return this.plainTextContent.length; },
    charCountClass() {
      if (this.plainTextLength > this.charLimit) return 'p-error';
      else if (this.plainTextLength > this.charLimit * 0.9) return 'p-text-warning';
      return 'p-text-secondary';
    }
  },
  async created() {
    await this.loadProvider();
    await this.loadTemplate();
  },
  methods: {
    addRule() {
        this.replyRules.push({
            id: Date.now() + Math.random(),
            keyword: '',
            action_key: null,
            reply_message: '',
            reply_failure_message: ''
        });
    },
    removeRule(index) {
        this.replyRules.splice(index, 1);
    },
    async loadProvider() {
        try {
            const response = await notificationsService.getAllProviders();
            if (response && response.data) {
                const smsProvider = response.data.find(p => p.code === 'sms');
                if (smsProvider) {
                    this.providerId = smsProvider.id;
                    this.charLimit = smsProvider.char_limit || 290;
                    if (smsProvider.available_tags) {
                         this.availableTags = smsProvider.available_tags.map(tag => {
                            const nameMap = {
                              'nopat': 'Nº PAT',
                              'brand': 'Marca'
                            };
                            return { name: nameMap[tag] || tag, value: tag };
                        });
                    }
                }
            }
        } catch (e) { console.error(e); }
    },

    async loadTemplate() {
      this.loading = true;
      try {
        const response = await notificationsService.getTemplates('sms');
        if (!response || !response.data) return;

        const template = response.data.templates.find(t => t.code === 'sms-request-equipment-documentation');

        if (template) {
          this.templateId = template.id;
          this.form = {
            code: template.code,
            name: template.name,
            description: template.description || '',
            content: template.content,
            is_active: template.is_active
          };

          if (template.reply_rules) {
              this.replyRules = template.reply_rules.map(rule => ({
                  ...rule,
                  id: rule.id || Date.now() + Math.random()
              }));
          } else {
              this.replyRules = [];
          }
        }
      } catch (error) {
        this.$toast.add({ severity: 'error', summary: 'Erro', detail: 'Erro ao carregar template.' });
      } finally {
        this.loading = false;
      }
    },

    async save() {
      if (this.plainTextLength > this.charLimit) {
        this.$toast.add({ severity: 'warn', summary: 'Aviso', detail: 'Limite de caracteres excedido.' });
        return;
      }

      this.loading = true;
      try {
        const payload = {
            ...this.form,
            reply_rules: this.replyRules
        };

        let response;
        if (this.templateId) {
          response = await notificationsService.updateTemplate('sms', this.templateId, payload);
        } else {
          response = await notificationsService.createTemplate('sms', payload);
        }

        if (response) {
            this.$toast.add({ severity: 'success', summary: 'Sucesso', detail: 'Configuração gravada!' });
            await this.loadTemplate();
        }
      } catch (error) {
        this.$toast.add({ severity: 'error', summary: 'Erro', detail: 'Erro ao gravar.' });
      } finally {
        this.loading = false;
      }
    },

    handleTextUpdate(text) { this.plainTextContent = text; },
    cancel() { this.loadTemplate(); },
    openTestDialog() {
      this.testForm.data = {};
      this.availableTags.forEach(tag => {
        this.testForm.data[tag.value] = '';
      });
      this.testForm.data.nopat = 'PAT12345';
      this.testForm.data.init_date = new Date().toLocaleDateString('pt-PT');

      this.updateTestPreview();
      this.testDialogVisible = true;
    },

    updateTestPreview() {
      let preview = this.plainTextContent;
      Object.keys(this.testForm.data).forEach(key => {
        const value = this.testForm.data[key] || `{{${key}}}`;
        preview = preview.replace(new RegExp(`\\{\\{${key}\\}\\}`, 'g'), value);
      });
      this.testPreview = preview;
    },

    async sendTest() {
      if (!this.testForm.recipient) {
        this.$toast.add({
          severity: 'warn',
          summary: 'Aviso',
          detail: 'Por favor, insira um número de telefone.',
          life: 3000
        });
        return;
      }

      if (!this.templateId) {
        this.$toast.add({
          severity: 'warn',
          summary: 'Aviso',
          detail: 'Por favor, guarde o template antes de testar.',
          life: 3000
        });
        return;
      }

      this.testLoading = true;
      try {
        const response = await notificationsService.sendTestNotification(
          'sms',
          this.templateId,
          this.testForm
        );

        if (response && response.success) {
          this.$toast.add({
            severity: 'success',
            summary: 'Sucesso',
            detail: 'SMS de teste enviado com sucesso!',
            life: 3000
          });
          this.testDialogVisible = false;
        } else {
          this.$toast.add({
            severity: 'error',
            summary: 'Erro',
            detail: 'Não foi possível enviar o SMS de teste.',
            life: 3000
          });
        }
      } catch (error) {
        this.$toast.add({
          severity: 'error',
          summary: 'Erro',
          detail: 'Não foi possível enviar o SMS de teste.',
          life: 3000
        });
      } finally {
        this.testLoading = false;
      }
    }
  },
  watch: {
    'testForm.data': {
      handler() {
        this.updateTestPreview();
      },
      deep: true
    }
  }
};
</script>

<style scoped>
.p-error { color: #f44336; font-weight: 600; }
.p-text-warning { color: #ff9800; font-weight: 600; }
.text-muted { color: #6c757d; }

.box-rule {
    background-color: #f8f9fa;
    border: 1px solid #dee2e6;
    border-radius: 6px;
    padding: 1rem;
    transition: all 0.2s;
}
.box-rule:hover {
    border-color: #ced4da;
    background-color: #fff;
}

.box-empty {
    border: 1px dashed #ced4da;
    border-radius: 6px;
    color: #6c757d;
    background-color: #f8f9fa;
}

.label-small {
    font-size: 0.85rem;
    font-weight: 600;
    color: #495057;
    display: block;
    margin-bottom: 0.3rem;
}

.list-enter-active, .list-leave-active { transition: all 0.3s; }
.list-enter, .list-leave-to { opacity: 0; transform: translateY(10px); }
</style>